export const CERTIFICATE_SYSCODE = {
  Reserved: 0,
  SANDBOX_NETS_QR_Web: 1,
  SANDBOX_NETS_QR_Mobile: 2,
  SANDBOX_eNETS_Web: 3,
  UAT_NETS_Click: 4,
  UAT_NETS_QR_Web: 5,
  UAT_NETS_QR_Mobile: 6,
  UAT_eNETS_Web: 7,
  UAT_eNETS_Mobile: 8,
  GO_LIVE_NETS_Click: 9,
  GO_LIVE_NETS_QR_Web: 10,
  GO_LIVE_NETS_QR_Mobile: 11,
  GO_LIVE_eNETS_Web: 12,
  GO_LIVE_eNETS_Mobile: 13,
}

export const CertificateSyscodeString = {
  [CERTIFICATE_SYSCODE.Reserved]: "Reserved",
  [CERTIFICATE_SYSCODE.SANDBOX_NETS_QR_Web]: "(Sandbox) NETS QR (Web)",
  [CERTIFICATE_SYSCODE.SANDBOX_NETS_QR_Mobile]: "(Sandbox) NETS QR (Mobile)",
  [CERTIFICATE_SYSCODE.SANDBOX_eNETS_Web]: "(Sandbox) eNETS (Web)",
  [CERTIFICATE_SYSCODE.UAT_NETS_Click]: "(UAT) NETS Click",
  [CERTIFICATE_SYSCODE.UAT_NETS_QR_Web]: "(UAT) NETS QR (Web)",
  [CERTIFICATE_SYSCODE.UAT_NETS_QR_Mobile]: "(UAT) NETS QR (Mobile)",
  [CERTIFICATE_SYSCODE.UAT_eNETS_Web]: "(UAT) eNETS (Web)",
  [CERTIFICATE_SYSCODE.UAT_eNETS_Mobile]: "(UAT) eNETS (Mobile)",
  [CERTIFICATE_SYSCODE.GO_LIVE_NETS_Click]: "(Go Live) NETS Click",
  [CERTIFICATE_SYSCODE.GO_LIVE_NETS_QR_Web]: "(Go Live) NETS QR (Web)",
  [CERTIFICATE_SYSCODE.GO_LIVE_NETS_QR_Mobile]: "(Go Live) NETS QR (Mobile)",
  [CERTIFICATE_SYSCODE.GO_LIVE_eNETS_Web]: "(Go Live) eNETS (Web)",
  [CERTIFICATE_SYSCODE.GO_LIVE_eNETS_Mobile]: "(Go Live) eNETS (Mobile)",
};

export const CertificateSyscodeMap = {
  Staging: [
    CERTIFICATE_SYSCODE.UAT_NETS_Click,
    CERTIFICATE_SYSCODE.UAT_NETS_QR_Web,
    CERTIFICATE_SYSCODE.UAT_NETS_QR_Mobile,
    CERTIFICATE_SYSCODE.UAT_eNETS_Web,
    CERTIFICATE_SYSCODE.UAT_eNETS_Mobile
  ],
  Sandbox: [
    CERTIFICATE_SYSCODE.SANDBOX_NETS_QR_Web,
    CERTIFICATE_SYSCODE.SANDBOX_NETS_QR_Mobile,
    CERTIFICATE_SYSCODE.SANDBOX_eNETS_Web
  ],
  Production: [
    CERTIFICATE_SYSCODE.GO_LIVE_NETS_Click,
    CERTIFICATE_SYSCODE.GO_LIVE_NETS_QR_Web,
    CERTIFICATE_SYSCODE.GO_LIVE_NETS_QR_Mobile,
    CERTIFICATE_SYSCODE.GO_LIVE_eNETS_Web,
    CERTIFICATE_SYSCODE.GO_LIVE_eNETS_Mobile
  ]
};

export const CertificateSyscodeByCoursework = {
  "NETS QR (Web)": [
    CERTIFICATE_SYSCODE.SANDBOX_NETS_QR_Web,
    CERTIFICATE_SYSCODE.UAT_NETS_QR_Web,
    CERTIFICATE_SYSCODE.GO_LIVE_NETS_QR_Web
  ],
  "NETS QR (Mobile)": [
    CERTIFICATE_SYSCODE.SANDBOX_NETS_QR_Mobile,
    CERTIFICATE_SYSCODE.UAT_NETS_QR_Mobile,
    CERTIFICATE_SYSCODE.GO_LIVE_NETS_QR_Mobile
  ],
  "eNETS (Web)": [
    CERTIFICATE_SYSCODE.SANDBOX_eNETS_Web,
    CERTIFICATE_SYSCODE.UAT_eNETS_Web,
    CERTIFICATE_SYSCODE.GO_LIVE_eNETS_Web
  ],
  "eNETS (Mobile)": [
    CERTIFICATE_SYSCODE.UAT_eNETS_Mobile,
    CERTIFICATE_SYSCODE.GO_LIVE_eNETS_Mobile
  ],
  "NETS Click": [
    CERTIFICATE_SYSCODE.UAT_NETS_Click,
    CERTIFICATE_SYSCODE.GO_LIVE_NETS_Click
  ]
};

export const CertificateSyscodeByCourseworkNetsOnly = {
  "NETS QR (Web)": CertificateSyscodeByCoursework["NETS QR (Web)"],
  "NETS QR (Mobile)": CertificateSyscodeByCoursework["NETS QR (Mobile)"],
  "eNETS (Web)": CertificateSyscodeByCoursework["eNETS (Web)"],
  "eNETS (Mobile)": CertificateSyscodeByCoursework["eNETS (Mobile)"],
  "NETS Click": CertificateSyscodeByCoursework["NETS Click"]
};